import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from "@faire/web--source/slate/Button";
import React from "react";
import { SlateText } from "../Text/SlateText";
export var SlateButton = function(param) {
    var variant = param.variant, textElement = param.textElement, onClick = param.onClick, linkTo = param.linkTo;
    if (!(textElement === null || textElement === void 0 ? void 0 : textElement.text)) {
        return null;
    }
    return /*#__PURE__*/ _jsx(Button, {
        variant: variant,
        onClick: onClick,
        linkTo: linkTo,
        children: /*#__PURE__*/ _jsx(SlateText, {
            textElement: textElement,
            isUnderlined: true
        })
    });
};
